// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3QRQe","inner":"Footer_inner__cJ10Q"};